module.exports = __webpack_public_path__ + "app-static/img/icon-shz.1ce2ec75.png";